const PAGES = {
    home: { id: 1, icon: 'fas fa-home', title: '主页', name: 'home', to: '/', path: '/' },

    sendOrder: { id: 1, icon: 'fas fa-paper-plane', title: '发送订单', name: 'sendOrder', to: '/send-order', path: '/send-order' },
    materialData: { id: 1, icon: 'fas fa-cube', title: '物料数据', name: 'materialData', to: '/material-data', path: '/material-data' },
    listPrice: { id: 1, icon: 'fas fa-dollar-sign', title: '列表价', name: 'listPrice', to: '/list-price', path: '/list-price' },
    materialComp: { id: 1, icon: 'fas fa-cubes', title: '物料综合', name: 'materialComp', to: '/material-comp', path: '/material-comp' },
    quotation: { id: 1, icon: 'fas fa-file-invoice-dollar', title: '报价单', name: 'quotation', to: '/quotation', path: '/quotation' },
    quotationOms: { id: 1, icon: 'fas fa-file-invoice', title: '报价单OMS', name: 'quotationOms', to: '/quotation-oms', path: '/quotation-oms' },
    purchaseOrder:{ id: 1, icon: 'fas fa-list-alt', title: '采购订单', name: 'purchaseOrder', to: '/purchase-order', path: '/purchase-order' },
    orderConfirmation:{ id: 1, icon: 'fas fa-calendar-check', title: '订单确认', name: 'orderConfirmation', to: '/order-confirmation', path: '/order-confirmation' },
    proformaInvoice:{ id: 1, icon: 'fas fa-receipt', title: '形式发票', name: 'proformaInvoice', to: '/proforma-invoice', path: '/proforma-invoice' },
    shippingNotice:{ id: 1, icon: 'fas fa-file-invoice', title: '发货通知', name: 'shippingNotice', to: '/shipping-notice', path: '/shipping-notice' },
    deliveryDetails:{ id: 1, icon: 'fas fa-list-ol', title: '发货明细', name: 'deliveryDetails', to: '/delivery-details', path: '/delivery-details' },
    purchaseReceipt:{ id: 1, icon: 'fas fa-scroll', title: '外购入库单', name: 'purchaseReceipt', to: '/purchase-receipt', path: '/purchase-receipt' },
    inventoryInformation:{ id: 1, icon: 'fas fa-warehouse', title: '库存信息', name: 'inventoryInformation', to: '/inventory-information', path: '/inventory-information' },
    downstreamSales:{ id: 1, icon: 'fas fa-poll-h', title: '下游销售', name: 'downstreamSales', to: '/downstream-sales', path: '/downstream-sales' },

    invetory: { id: 2, icon: 'fa fa-shopping-cart', title: '库存信息', name: 'invetory', to: '/invetory', path: '/invetory' },
    sales:{ id: 3, icon: 'fas fa-calendar-check', title: '下游销售', name: 'sales', to: '/sales', path: '/sales' },
    invoice:{ id: 4, icon: 'fas fa-clipboard-list', title: '发票数据', name: 'invoice', to: '/invoice', path: '/invoice' },
    serviceState:{id: 5, icon: 'fab fa-windows', title: 'EDI服务状态', name: 'sevice-state', to: '/sevice-state', path: '/sevice-state'},
    logs:{id: 6, icon: 'fas fa-file-medical-alt', title: '日志监控', name: 'logs', to: '/logs', path: '/logs'},
    system:{id: 7, icon: 'fas fa-cogs', title: '系统配置', name: 'system', to: '/system', path: '/system'},
    erpFields:{ id: 8, icon: 'fas fa-coins', title: 'ERP更新配置', name: 'erpfields', to: '/erp-fields', path: '/erp-fields' },
    regcustomer:{ id: 8, icon: 'fas fa-address-book', title: '注册客户', name: 'regcustomer', to: '/regcustomer', path: '/regcustomer' },
}
const pagesArr = Object.values(PAGES)
const pages = {
    pagesObj: PAGES,
    pagesArr,
}
function matchPage(path) {
    if (path.startsWith('/quotation-oms')) {
        path = '/quotation-oms'
    }
    for (let i = 0; i < pagesArr.length; i++) {
        if (pagesArr[i].path === path) {
            return pagesArr[i]
        }
    }
    return null
}

const LeftMenuData = {
    left_menu: {
        status: true,
        menus: [
            [
                // PAGES.sendOrder,
                PAGES.materialData,
                PAGES.listPrice,
                PAGES.materialComp,
                PAGES.quotation,
                PAGES.purchaseOrder,
                PAGES.orderConfirmation,
                PAGES.proformaInvoice,
                PAGES.shippingNotice,
                PAGES.deliveryDetails,
                PAGES.purchaseReceipt,
                PAGES.inventoryInformation,
                PAGES.downstreamSales,
            ],
            // [
            //     PAGES.invetory,
            //     // PAGES.invoice,
            //     PAGES.sales
            // ],
            [
                PAGES.serviceState,
                // PAGES.logs,
                // PAGES.erpFields,
                // PAGES.regcustomer,
                PAGES.system
            ]
        ]
    }
}


const rightDrawerSatus = {
    right_drawer: {
        status: true,
    }
}

const base_tabs = [PAGES.invetory]


const stickyTab = {
    //如果是erp登录  navbar默认是空  如果是入口登录的,navbar默认是ERP采购订单
    tabs: sessionStorage.getItem('emis-page-sticky-tabs') ? JSON.parse(sessionStorage.getItem('emis-page-sticky-tabs')) : base_tabs
}

const state = () => ({
    page: Object.assign({}, LeftMenuData, rightDrawerSatus, stickyTab, pages)
})
const getters = {
    BaseMenu: state => state.page.left_menu,
    drawerStatus: state => state.page.right_drawer.status,
    getStickyTabs: state => state.page.tabs,
    // dialogStatus: state => state.page.defalutDialog.status
    pagesObj: state => state.page.pagesObj,
    pagesArr: state => state.page.pagesArr,
    tabs: state => state.page.tabs,
}
const mutations = {
    ['change-left-menu-status'](state) {
        state.page.left_menu.status = !state.page.left_menu.status
    },
    ['change-right-drawer-status'](state) {
        state.page.right_drawer.status = !state.page.right_drawer.status
    },
    ['add_tab'](state, data) {
        let tabs = state.page.tabs
        let obj = tabs.filter(it => {
            return it.name == data.name
        })
        if (obj.length < 1) {
            tabs.push(data)
            sessionStorage.setItem('emis-page-sticky-tabs', JSON.stringify(tabs))
        }
    },
    ['delete_tab'](state, data) {
        let obj = state.page.tabs.filter(it => {
            return it.name != data.name
        })
        state.page.tabs = obj
        sessionStorage.setItem('emis-page-sticky-tabs', JSON.stringify(obj))
    },
}
const actions = {
    ['add_sticky_tab']({ state, commit }, payload) {
        console.log(payload,'payloadpayloadpayload');
        let ms = state.page.left_menu.menus
        let obj = {}
        let res = matchPage(payload.path)
        if (res && res.name !== PAGES.home.name) {
            obj.icon = res.icon
            obj.name = res.name
            obj.path = res.to
            obj.title = res.title
            if (payload.params) {
                obj.params = payload.params
            }
            commit('add_tab', obj)
        }
    },
    ['delete_sticky_tab']({ commit }, payload) {
        commit('delete_tab', payload)
    },
}
export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
}
